export const BE_HEALTHIER = '1'
export const LOSE_WEIGHT = '2'
export const GET_STRONGER = '0'

export default [BE_HEALTHIER, GET_STRONGER, LOSE_WEIGHT]
